import { render } from "./DraftEvent.vue?vue&type=template&id=5620b630&scoped=true"
import script from "./DraftEvent.vue?vue&type=script&lang=js"
export * from "./DraftEvent.vue?vue&type=script&lang=js"

import "./DraftEvent.vue?vue&type=style&index=0&id=5620b630&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5620b630"

export default script